import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch { /* ignore */ }
  }, []);

  const accept = (all) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: all, at: new Date().toISOString() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#0B1E36] text-white border-t border-white/10 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-[#FF6A00] shrink-0 mt-0.5" />
          <p className="text-sm leading-relaxed text-slate-200">
            Utilizamos cookies para melhorar a sua experiência e garantir o funcionamento do website.{" "}
            <a href="/cookies" className="text-[#FF6A00] underline hover:text-white" data-testid="cookie-policy-link">
              Saiba mais na Política de Cookies
            </a>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button onClick={() => accept(false)} data-testid="cookie-reject"
            className="text-xs font-semibold px-5 py-2.5 border border-white/25 text-slate-200 hover:bg-white/10 transition-colors">
            Só Necessários
          </button>
          <button onClick={() => accept(true)} data-testid="cookie-accept"
            className="text-xs font-semibold px-5 py-2.5 bg-[#FF6A00] hover:bg-[#e65f00] text-white transition-colors">
            Aceitar Todos
          </button>
        </div>
      </div>
    </div>
  );
}
